import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

export const useWebSocket = () => {
  const [wsData, setWsData] = useState(null);
  const wsRef = useRef(null);
  const navigate = useNavigate();

  const startWebSocket = (url, onMessageCallback) => {
    wsRef.current = new WebSocket(url);

    wsRef.current.onopen = () => {
      //console.log("WebSocket connected:", url);
    };

    wsRef.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setWsData(data);
      localStorage.setItem("websocketRes", JSON.stringify(data));

      if (onMessageCallback) {
        onMessageCallback(data, navigate);
      }
    };

    wsRef.current.onclose = () => {
      //console.log("WebSocket disconnected");
    };

    wsRef.current.onerror = (err) => {
      //console.error("WebSocket error:", err);
      wsRef.current.close();
    };
  };

  const stopWebSocket = () => {
    if (wsRef.current) wsRef.current.close();
  };

  return { wsData, startWebSocket, stopWebSocket };
};
